import constants from "./Constants";

const handleIntersection = async (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
    if (!entries[0].isIntersecting) return;
    const scroller = entries[0].target as HTMLDivElement;
    observer.unobserve(scroller);
    try {
        const response = await fetch(scroller.dataset.url);
        const data = await response.text();
        const html = document.createElement("div");
        html.innerHTML = data;
        scroller.replaceChildren(...html.querySelector(constants.SELECTORS.SCROLLER).childNodes);
        scroller.dispatchEvent(new CustomEvent(constants.EVENTS.TILES_LOADED, { detail: scroller }));
    } catch (error) {
        console.error(error);
    }
};

const scrollerLoader = document.querySelectorAll(
    `${constants.SELECTORS.SCROLLER}[data-url]`
) as NodeListOf<HTMLDivElement>;
if (scrollerLoader.length) {
    scrollerLoader.forEach((scroller) => {
        const observer = new IntersectionObserver(handleIntersection, { rootMargin: "0px 0px 200px 0px" });
        observer.observe(scroller);
    });
}
